export default "__VITE_ASSET__B2Zu7YML__";